<template>
  <v-bottom-sheet v-model="day.status">
    <div class="appointment-list">
      <div class="al-header">
        <b class="week-date">
          {{ formattedDateWeek }}
        </b>
        <br />
        {{ formattedDate(day.date) }}
      </div>
      <div class="al-stats">
        <div class="content">
          <div
            class="item"
            :style="
              workingServices.length == 0 && finishedServices.length == 0
                ? { width: '100%' }
                : ''
            "
          >
            <div class="total">
              {{ day.appointments ? day.appointments.length : 0 }}
            </div>
            <div class="description">Compromissos</div>
          </div>
          <div
            v-if="workingServices.length > 0 || finishedServices.length > 0"
            class="item"
            style="margin: 0px 10px"
          >
            <div class="total">{{ workingServices.length }}</div>
            <div class="description">trabalhando</div>
          </div>
          <div
            v-if="workingServices.length > 0 || finishedServices.length > 0"
            class="item"
          >
            <div class="total">{{ finishedServices.length }}</div>
            <div class="description">finalizados</div>
          </div>
        </div>
      </div>
      <div class="al-body">
        <div @click="newAppointment()" class="add-button">
          + NOVO AGENDAMENTO
        </div>
        <div
          class="al-title"
          v-if="day.appointments && day.appointments.length > 0"
        >
          Compromissos
        </div>
        <div
          @click="editAppointment(appointment)"
          v-for="appointment in day.appointments"
          :key="appointment.id"
          class="al-compromise"
        >
          <div class="c-title d-flex justify-space-between align-center">
            <div class="appointment-head-info" :title="appointment.title">
              <div class="appointment-time-status">
                <b>{{ getHours(appointment.forecast) }} | {{ appointment_status[appointment.status] }}</b>
              </div>
              <div class="appointment-title">
                {{ appointment.title }}
              </div>
            </div>
            <div style="width: 120px; padding-left: 8px; float: right; text-align: right;">
              <v-tooltip v-if="appointment.client && appointment.client.phone" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-4"
                    color="#3f505f"
                    @click.stop="openWhatsapp(appointment)"
                  >mdi-whatsapp</v-icon>
                </template>
                <span>{{ appointment.client && appointment.client.phone ? appointment.client.phone : ''  }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="btn-check-presence"
                    :color="appointment.status == 'present' ? '#48b38b' : '#3f505f'"
                    @click.stop="markPresence(appointment.id, true)"
                  >mdi-thumb-up</v-icon>
                </template>
                <span>MARCAR PRESENÇA</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="ml-4 btn-check-lack"
                    :color="appointment.status == 'missed' ? '#E57373' : '#3f505f'"
                    @click.stop="markPresence(appointment.id, false)"
                  >mdi-thumb-down</v-icon>
                </template>
                <span>MARCAR FALTA</span>
              </v-tooltip>
            </div>
          </div>
          <div v-if="appointment.observation" class="c-description">
            {{ appointment.observation }}
          </div>
          <div class="c-responsibles">
            Prioridade:
            <b>{{ getAppointmentPriority(appointment.priority) }}</b> |
            Responsável:
            <b>{{
              getAppointmentResponsibles(appointment.appointment_responsibles)
            }}</b>
          </div>
        </div>
        <div v-if="workingServices.length > 0" class="al-title">
          Trabalhando
        </div>
        <v-card
          v-for="service in workingServices"
          :key="service.id"
          outlined
          style="z-index: 0; border-left: 5px solid #eee; margin-bottom: 15px"
        >
          <v-list-item two-line class="mx-0 px-2">
            <v-list-item-content>
              <div class="os-status mr-3">
                {{ getServiceStatus(service.status) }}
              </div>
              <div class="os-status">
                Previsão {{ formattedDate(service.forecast_date) }}
              </div>
              <v-list-item-title class="text-h5 mb-1">
                {{
                  service.client
                    ? service.client.name
                    : 'Cliente não especificado'
                }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                service.vehicle ? service.vehicle.description : ''
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon
              style="
                margin: 12px 0px 0px;
                width: 100px;
                text-align: center;
                overflow: hidden;
                background-color: rgb(238, 238, 238);
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
              "
            >
              <div
                v-if="service.vehicle"
                style="overflow: hidden; padding-bottom: 6px"
              >
                <img
                  :src="service.vehicle.vehicle_plate_photo_url"
                  height="35px"
                  width="100%"
                />
                <span style="with: 100%">{{
                  timeDiference(service.created_at)
                }}</span>
              </div>
            </v-list-item-icon>
          </v-list-item>
        </v-card>
        <div v-if="finishedServices.length > 0" class="al-title">
          Finalizados (Previsão)
        </div>
        <v-card
          v-for="service in finishedServices"
          :key="service.id"
          outlined
          style="
            z-index: 0;
            border-left: 5px solid #48b38b;
            margin-bottom: 15px;
          "
        >
          <v-list-item two-line class="mx-0 px-2">
            <v-list-item-content>
              <div class="os-status">
                {{ getServiceStatus(service.status) }}
              </div>
              <v-list-item-title class="text-h5 mb-1">
                {{
                  service.client
                    ? service.client.name
                    : 'Cliente não especificado'
                }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                service.vehicle ? service.vehicle.description : ''
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon
              style="
                margin: 12px 0px 0px;
                width: 100px;
                text-align: center;
                overflow: hidden;
                background-color: rgb(238, 238, 238);
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
              "
            >
              <div
                v-if="service.vehicle"
                style="overflow: hidden; padding-bottom: 6px"
              >
                <img
                  :src="service.vehicle.vehicle_plate_photo_url"
                  height="35px"
                  width="100%"
                />
                <span style="with: 100%">{{
                  timeDiference(service.created_at)
                }}</span>
              </div>
            </v-list-item-icon>
          </v-list-item>
        </v-card>
        <small v-if="workingServices.length > 0 || finishedServices.length > 0"
          >*Obs: O tempo de estadia dos carros é calculado com base no dia atual
          ({{ formattedDate() }}).</small
        >
      </div>
    </div>
  </v-bottom-sheet>
</template>

<script>
import dayjs from 'dayjs';
import OrganizationStatusService from '@/services/api/organizationStatus';
import SchedulingService from '@/services/api/scheduling';

export default {
  props: {
    day: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    appointment_status: {
      confirmed: 'CONFIRMADO',
      canceled: 'CANCELADO',
      waiting_confirm: 'AGUARDANDO CONFIRMAÇÃO',
      created: 'CRIADO',
      present: 'PRESENTE',
      missed: 'FALTA',
    },
    service_status_list: [],
  }),

  computed: {
    formattedDateWeek() {
      return dayjs(this.day.date).locale('pt-br').format('dddd');
    },
    workingServices() {
      const self = this;
      return self.day && self.day.services
        ? self.day.services.filter(
            (service) => !service.forecast_date.includes(self.day.date),
          )
        : [];
    },
    finishedServices() {
      const self = this;
      return self.day && self.day.services
        ? self.day.services.filter((service) =>
            service.forecast_date.includes(self.day.date),
          )
        : [];
    },
  },
  mounted() {
    this.getOrganizationStatus();
  },
  methods: {
    openWhatsapp(appointment) {
      if (!appointment.client?.phone) {
        return;
      }

      const phone = appointment.client.phone.match(/\d+/g).join('');
      const message = `Olá ${appointment.client.name}, tudo bem? Gostaríamos de confirmar seu agendamento para ${this.formattedDate(appointment.forecast)} às ${this.getHours(appointment.forecast)}.`;
      window.open(`whatsapp://send?phone=55${phone}&text=${encodeURIComponent(message)}`);
    },
    markPresence(appointmentId, presence) {
      const appointment = this.day.appointments.find(app => app.id === appointmentId);
      if (appointment) {
        appointment.status = presence ? 'present' : 'missed';
      }

      SchedulingService.markPresence(appointmentId, presence)
        .then(() => {
          this.$toast.success(
            presence ? 'Presença marcada com sucesso!' : 'Falta marcada com sucesso!',
            {
              duration: 3000,
              position: 'bottom-right'
            }
          );
          
          this.$emit('appointmentPresence', appointmentId, presence);
        })
        .catch((error) => {
          console.error('Erro ao marcar presença:', error);
          this.$toast.error('Erro ao marcar presença/falta', {
            duration: 3000,
            position: 'bottom-right'
          });
        });
    },
    async getOrganizationStatus() {
      try {
        const { data } = await OrganizationStatusService.search();
        if (data && data.length > 0) {
          this.service_status_list = data;
        } else {
          this.service_status_list = this.$store.getters['General/organization_status_list'];
        }
      } catch (error) {
        console.error('Erro ao buscar status da organização:', error);
        this.service_status_list = this.$store.getters['General/organization_status_list'];
      }
    },
    getAppointmentResponsibles(responsibles) {
      if (!responsibles || responsibles.length === 0) {
        return 'Não especificado';
      }
      return responsibles
        .map((responsible) => responsible.user.name)
        .join(' / ');
    },
    getAppointmentPriority(priority) {
      const priorities = [
        { value: 'little_urgent', text: 'Pouco urgente' },
        { value: 'priority', text: 'Prioritária' },
        { value: 'important', text: 'Importante' },
        { value: 'critical', text: 'Crítico' },
      ];

      const priorityObj = priorities.find((p) => p.value === priority);
      return priorityObj ? priorityObj.text : '';
    },
    newAppointment() {
      this.$emit('newAppointment', this.day.date);
    },
    formattedDate(date) {
      return dayjs(date).locale('pt-br').format('DD/MM/YYYY');
    },
    getHours(date) {
      return dayjs(date).locale('pt-br').format('HH:mm');
    },
    getLastResponsible(service) {
      return service.service_order_responsibles.length > 0
        ? service.service_order_responsibles.slice(-1)[0].user.name
        : service.created_by_user.name;
    },
    editAppointment(appointment) {
      this.$emit('editAppointment', appointment);
    },
    timeDiference(date) {
      const t0 = new Date(date);
      const t1 = new Date();
      const d = new Date(t1) - new Date(t0);
      const weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
      const days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
      const hours = Math.floor(
        d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24,
      );
      const minutes = Math.floor(
        d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60,
      );

      let time = '';

      if (weekdays > 0) {
        time += `${weekdays}s `;
      }
      if (days > 0) {
        time += `${days}d `;
      }
      if (hours > 0) {
        time += `${hours}h `;
      }
      if (minutes > 0) {
        time += `${minutes}m `;
      }

      return time;
    },
    getServiceStatus(statusRef) {
      const status = this.service_status_list.find(
        (status) => status.code === statusRef,
      );
      return status ? status.title : null;
    },
  },
};
</script>

<style lang="scss">
.appointment-list {

  .os-status {
    background-color: rgb(238, 238, 238);
    border-radius: 5px;
    flex: none;
    font-size: 11px;
    padding: 3px 5px;
  }

  .al-header {
    min-height: 120px;
    color: #fff;
    background-color: #48B38B;
    font-size: 28px;
    padding-top: 15px;
    text-transform: uppercase;
    text-align: center;
    position: absolute;
    width: 100%;
    margin-top: -1px;
    z-index: 999;

    .week-date {
      letter-spacing: 1px;
    }

    div {
      width: 100%;
      float: left;
    }
  }

  .al-stats {
    background-color: #eee;
    padding: 15px;
    padding-top: 135px;

    .content {
      display: flex;
      align-items: center;
      overflow: hidden;
      justify-content: center;

      .item {
        text-align: center;
        background-color: #fff;
        padding: 10px 14px;
        border-radius: 6px;

        .total {
          font-weight: bold;
        }

        .description {
          text-transform: uppercase;
          font-size: 12px;
        }
      }
    }
  }

  .al-body {
    min-height: 300px;
    padding: 20px;

    .add-button {
      text-align: center;
      border: 1px dashed rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      padding: 10px 20px;
      margin-bottom: 15px;
      margin-top: 3px;
    }

    .al-title {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 15px;
      margin: 10px 0px;
    }

    .al-compromise {
      border: 1px solid rgb(197, 197, 197);
      border-radius: 6px;
      margin-bottom: 15px;

      .appointment-head-info {
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: nowrap;
        max-width: 325px;
      }

      .appointment-time-status {
        font-size: 14px;
        margin-bottom: 4px;
      }

      .appointment-title {
        font-size: 15px;
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .c-title {
        padding: 10px;
        background-color: #eee;
        font-size: 15px;
      }

      .c-description {
        padding: 10px;
        border-bottom: 2px solid #ebebeb;
      }

      .c-responsibles {
        padding: 10px;
        font-size: 13px;
      }
    }
  }
}
</style>
